import { Shoppable, PlayerSkin } from '@kaskus-tv/shared/lib/models';
import gql from 'graphql-tag';

import { USER_SCORE, WATCH_TYPE, RESTRICTION_TYPE } from 'src/app/constants/video';
import { Player } from 'src/app/models/player';
import { Playlist } from 'src/app/models/playlist';
import { Program, PROGRAM_FRAGMENT } from 'src/app/models/program';
import { Teaser } from 'src/app/models/teaser';

export interface VideoForPlayer extends VideoWithViewToken {
  category?: string;
  largeThumbnail: string;
  program: {
    id: string;
    name: string;
    channel?: {
      id: string;
      name: string;
    };
  };
  publishedAt: string;
  type: WATCH_TYPE;
  player: Player | null;
  tags?: string[];
  shoppable?: Shoppable;
  playerSkin?: PlayerSkin | null;
  teaser?: Teaser;
  restrictionList?: RESTRICTION_TYPE[];
}

export interface VideoSearchSnippet {
  id: string;
  duration: number;
  title: string;
  thumbnail: string;
}

export interface Video {
  duration: number;
  id: string;
  isInWatchlist: boolean;
  title: string;
  viewCount: number;
  inPlaylists: Playlist[];
}

export interface VideoWithViewToken extends Video {
  viewToken: string;
}

export interface VideoCard extends Video {
  thumbnail: string;
  program: Program;
}

export interface VideoWithScore extends Video {
  score: {
    dislike: number;
    like: number;
    userScore: USER_SCORE;
  };
}

export interface VideoForSchema extends Video {
  channel: {
    avatar: string;
    name: string;
    slug: string;
  };
  description: string;
  publishedAt: string;
  embedUrl: string;
  thumbnail: string;
  largeThumbnail: string;
}

export const VIDEO_FRAGMENT = gql`
  fragment Video on GQLVideo {
    duration
    id
    isInWatchlist
    inPlaylists {
      id
      name
    }
    title
    viewCount
  }
`;

export const VIDEO_WITH_VIEW_TOKEN_FRAGMENT = gql`
  fragment VideoWithViewToken on GQLVideo {
    ...Video
    viewToken
  }
  ${VIDEO_FRAGMENT}
`;

export const VIDEO_CARD_FRAGMENT = gql`
  fragment VideoCard on GQLVideo {
    ...Video
    thumbnail
    program {
      ...Program
    }
  }
  ${VIDEO_FRAGMENT}
  ${PROGRAM_FRAGMENT}
`;

export const VIDEO_SCORE_FRAGMENT = gql`
  fragment VideoWithScore on GQLVideo {
    ...Video
    score {
      dislike
      like
      userScore
    }
  }
  ${VIDEO_FRAGMENT}
`;

export interface AddWatchlistResult {
  addVideoToWatchlist: {
    __typename: string;
    isInWatchlist: boolean;
  };
}
